import Message from "@/components/Message/Message";
import { useMutation, useQuery } from "@tanstack/react-query";
import { message, Progress, Space, Spin } from "antd";
import axios from "axios";
import { useState } from "react";
import { StatusUpload, StatusUploadStatus } from "../../useProducts";
import styles from "./UploadProductAction.module.scss";
import { CheckOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import DataUploadNotification from "@/components/DataUploadNotification/DataUploadNotification";

export default function UploadStatus({
  fileName,
  uuid,
  onSuccesfulUpload,
}: {
  fileName: string;
  uuid: string;
  onSuccesfulUpload: () => void;
}) {
  const [status, setStatus] = useState<StatusUploadStatus>("pending");
  const navigate = useNavigate();

  const getUploadStatus = useMutation({
    mutationFn: () =>
      axios
        .get<StatusUpload>("/products/upload_status?request_uuid=" + uuid)
        .then((result) => result.data),
    onSuccess: (result) => {
      setStatus(result.upload_status);
      if (result.upload_status === "success") {
        onSuccesfulUpload();
        if (result.total_new_products || result.total_bom_uploads) {
          DataUploadNotification({
            description: (
              <Space direction={"vertical"}>
                {result.total_bom_uploads > 0 && (
                  <Space>
                    <CheckOutlined style={{ color: "#52C41A" }} />
                    <span>{result.total_bom_uploads} BOM's</span>
                  </Space>
                )}
                {result.total_new_products > 0 && (
                  <Space
                    onClick={() => navigate("/products?showUnrelated=1")}
                    style={{ cursor: "pointer", textDecoration: "underline" }}
                  >
                    <CheckOutlined style={{ color: "#52C41A" }} />
                    <span>
                      {`${result.total_new_products} new product${
                        result.total_new_products > 1 ? "s" : ""
                      }`}
                    </span>
                  </Space>
                )}
              </Space>
            ),
          });
        }
      }
      if (result.upload_status === "failed") {
        message.error("Upload failed. Try again or contact support.");
      }
    },
  });

  const { data, isLoading, isFetching } = useQuery({
    queryKey: ["file_status", fileName],
    queryFn: () => getUploadStatus.mutateAsync(),
    refetchInterval: status === "pending" || status === "processing" ? 250 : false,
  });

  const loading = isLoading || isFetching || status === "processing" || status === "pending";

  return (
    <div className={styles.validate}>
      <div className={styles.report}>
        <span className={styles.title}>
          Uploading {fileName} {loading && <Spin size="small" />}
        </span>
        <Progress
          status={status === "failed" ? "exception" : undefined}
          percent={data?.complete_percentage}
        />
        {status === "success" && <Message type="success">Upload succesful.</Message>}
      </div>
    </div>
  );
}
